export default "__VITE_ASSET__8z5d1E8F__"